import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KendoGridDataConfig } from '../../_foundation/kendo/models/grid.models';
import { AppConfig } from '../../app/app.config';

@Injectable({
  providedIn: 'root'
})
export class ProjectDetailService {

  constructor(
    private http: HttpClient,
  ) {
  }

  getPhaseGridDataConfig(projectId: number): KendoGridDataConfig {
    const url = `${AppConfig.settings.apiUrl}api/project/detail/${projectId}/phase/grid/data`;
    return { name: 'project-detail-phase-grid', url: url };
  }

  getStageGridDataConfig(phaseId: number): KendoGridDataConfig {
    const url = `${AppConfig.settings.apiUrl}api/project/detail/${phaseId}/stage/grid/data`;
    return { name: 'project-detail-stage-grid', url: url };
  }

  getLocationGridDataConfig(stageId: number): KendoGridDataConfig {
    const url = `${AppConfig.settings.apiUrl}api/project/detail/${stageId}/location/grid/data`;
    return { name: 'project-detail-location-grid', url: url };
  }

  getCoaGridDataConfigForStage(stageId: number): KendoGridDataConfig {
    const url = `${AppConfig.settings.apiUrl}api/project/detail/stage/${stageId}/coa/grid/data`;
    return { name: 'project-detail-stage-coa-grid', url: url };
  }

  getCoaGridDataConfigForLocation(locationId: number): KendoGridDataConfig {
    const url = `${AppConfig.settings.apiUrl}api/project/detail/location/${locationId}/coa/grid/data`;
    return { name: 'project-detail-location-coa-grid', url: url };
  }
}



// WEBPACK FOOTER //
// ./src/services/setup/project-detail.service.ts